import React, {useState} from 'react'
import {FormHelperText, FormLabel, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import Tr from 'translations/Translations';
import Button from 'components/Button';
import SelectCPV from 'components/popup/selectCpv/SelectCPV';
import getObjectValue from 'libs/getObjectValue';
import Chip from './Chip';

const style = theme => ({
    root: {
        marginTop: theme.spacing()
    },
    chipLabel: {
        maxWidth: 250,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    buttonSelect: {
        marginRight: theme.spacing(2)
    }
})

function CPVSingleInput({
                      classes,
                      formikProps,
                      id,
                      required,
                      disabled,
                      label = Tr('cpv_code'),
                      skipCheckTouched
                  }) {

    const [openSelectCPV, setOpenSelectCPV] = useState(false)

    const handleClick = () => {
        setOpenSelectCPV(true)
        formikProps.setFieldTouched(id, true)
    }

    const handleClosePoup = () => {
        setOpenSelectCPV(false)
        formikProps.setFieldTouched(id, true)
    }

    const handleConfirm = (values) => {
        const elements = Object.keys(values).reduce((prevValue, currValue) => {
            if (!values[currValue]) return prevValue;
            return [
                ...prevValue,
                JSON.parse(currValue)
            ]
        }, [])
        handleClosePoup();
        formikProps.setFieldValue(id, elements[0])
    }

    const element = getObjectValue(id, formikProps.values, null)
    const errorValue = getObjectValue(id, formikProps.errors, '')
    const touched = getObjectValue(id, formikProps.touched, !!skipCheckTouched)
    const editable = getObjectValue('_editable', formikProps.values, true);
    const errorLabel = touched && errorValue ? errorValue : ' '


    const handleDelete = () => {
        formikProps.setFieldValue(id, null);
    }

    return (
        <div data-id={id}>
            <FormLabel>
                {label} {required && '*'}
            </FormLabel>
            <GridBlock
                className={classes.root}
                alignItems='center'
                wrap='nowrap'
                data-id={id}
            >
                {editable && !disabled && <Button
                    onClick={handleClick}
                    className={classes.buttonSelect}
                    disabled={!editable || disabled}
                >
                    {Tr('select')}
                </Button>}

                <GridBlock spacing={1}>
                    {!!element && <Chip
                        labelClassName={classes.chipLabel}
                        value={`${element.publicCode} ${element.name}`}
                        onDelete={editable && !disabled ? () => handleDelete() : undefined}
                    />
                    }
                </GridBlock>

            </GridBlock>
            <SelectCPV
                initValues={[]}
                open={openSelectCPV}
                onCancel={handleClosePoup}
                onConfirm={handleConfirm}
                label={label}
                multiple={false}
            />
            <FormHelperText error={touched && !!errorValue}>{errorLabel}</FormHelperText>
        </div>
    )
}

CPVSingleInput.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(CPVSingleInput);